{
    "account": "Conta",
    "add_bookmark": "Adicionar mensagem aos favoritos",
    "add_date": "Adicionar uma data",
    "ago": "{{duration}} atrás",
    "api_key": "Chave API",
    "are_you_sure": "Você tem certeza?",
    "ask_delete_message": "Deletar essa mensagem?",
    "audio_not_ready": "O áudio ainda não está pronto.",
    "bookmark_added": "Mensagem adicionada aos favoritos.",
    "bookmark_removed": "Mensagem removida dos favoritos.",
    "bookmarks": "Favoritos",
    "cancel": "Cancelar",
    "cancel_write": "Você realmente deseja cancelar a criação de uma nova mensagem?",
    "changed_group_name": "mudou o nome do grupo",
    "confirm_password_placeholder": "confirmar senha",
    "connect": "Conexão",
    "create_a_group": "Criar um grupo",
    "create_the_group": "Criar o grupo",
    "daily": "Diariamente",
    "default_group": "Grupo padrão",
    "delete": "Deletar",
    "destroy_account": "Deletar sua conta",
    "destroy_account_explain": "Depois de excluir sua conta, não há como voltar atrás. Por favor, tenha certeza.",
    "edit": "Editar",
    "email": "E-mail",
    "email_input": "Preencha seu endereço de e-mail aqui",
    "empty_message": "A mensagem está vazia e não pode ser enviada.",
    "error_new_message": "Um erro ocorreu ao enviar sua mensagem.",
    "error": "Um erro ocorreu",
    "error_upload": "Ocorreu um erro durante o envio",
    "forgot_password": "Esqueceu sua senha?",
    "group_left": "Você saiu do grupo.",
    "groups": "Grupos",
    "group_share_choice": "Para qual grupo você deseja enviar essa mensagem?",
    "group_updated": "O grupo foi atualizado.",
    "has_commented_on": "comentou em",
    "has_joined": "entrou",
    "has_left": "saiu",
    "has_posted_in": "postou em",
    "hourly": "Por Hora",
    "in": "em",
    "Invalid login/password": "Login e/ou senha inválidos",
    "invitation_link": "Link de convite",
    "invitation_welcome": "Bem-vindo ao Zusam. Registre-se antes de entrar no grupo.",
    "just_now": "Agora mesmo",
    "lang": "idioma",
    "login": "Entrar",
    "login_input": "Escolha um login",
    "login_placeholder": "e-mail",
    "logout": "Sair da sessão",
    "mark_all_as_read": "marcar todos como lido",
    "monthly": "Mensal",
    "multiple_photos_upload": "Ocorreu um erro. Tente fazer o upload das imagens uma a uma (isso pode ocorrer em alguns navegadores)",
    "name_input": "Escolher um nome",
    "name": "Nome",
    "new_password_placeholder": "nova senha",
    "next_coms": "Ver os próximos comentários",
    "none": "Nenhuma",
    "notification_emails": "Notificações de e-mail",
    "notification_emails_stopped": "As notificações de e-mail foram interrompidas!",
    "notifications": "notificações",
    "parent_message": "Mensagem relacionada",
    "password_input": "Escreva uma nova senha aqui",
    "password_placeholder": "senha",
    "password_reset_mail_sent": "Procure o e-mail de redefinição de senha em sua caixa de entrada.",
    "passwords_dont_match": "As senhas não coincidem",
    "password": "Senha",
    "previous_coms": "Ver comentários anteriores",
    "public_link": "link público",
    "publish_in_group": "publicar no grupo",
    "quit_group": "Sair do grupo",
    "remove_bookmark": "Remover mensagem dos favoritos",
    "replies_one": "{{count}} responder",
    "replies_other": "{{count}} respostas",
    "reply": "responder",
    "reset_api_key": "Redefinir a chave API (você será desconectado)",
    "reset_invitation_link": "Redefinir o link de convite",
    "reset_password_title": "Redefinir sua senha",
    "save_changes": "Salvar alterações",
    "search_in_group": "procurar neste grupo",
    "search_without_result": "Sua pesquisa não correspondeu a nenhuma mensagem.",
    "settings": "Configurações",
    "settings_updated": "Suas configurações foram atualizadas",
    "share_message": "compartilhe a mensagem",
    "signup": "Registrar-se",
    "submit": "Enviar",
    "text_placeholder": "Escreva sua mensagem aqui",
    "the_message_from": "a mensagem de",
    "title_placeholder": "Título da sua mensagem (opcional)",
    "to": "para",
    "upload_audio": "Adicionar um arquivo de áudio.",
    "upload_image": "Adicionar fotos",
    "upload_music": "Adicionar música",
    "upload_pdf": "Adicionar PDF",
    "upload_video": "Adicionar um vídeo",
    "User not found": "Usuário não encontrado",
    "users": "usuários",
    "video_not_ready": "O vídeo ainda não está pronto.",
    "weekly": "Semanalmente"
}
